import { defineStyle, defineStyleConfig } from '@chakra-ui/react';

const underline = defineStyle({
  textDecoration: 'underline',
});

const navigationBar = defineStyle({
  fontFamily: 'Barlow',
  fontWeight: 'medium',
  textDecoration: 'none',
  color: 'whiteAlpha.900',
  opacity: '0.5',
  _activeLink: {
    fontWeight: 'bold',
    opacity: 1,
  },
  _hover: {
    opacity: 1,
  },
});

const globalNavigation = defineStyle({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 1,
  width: 20,
  height: '58px',
  color: 'navigation.globalMuted',
  textDecoration: 'none',
  _hover: { background: 'whiteAlpha.100' },
});

const globalNavigationActive = defineStyle({
  ...globalNavigation,
  background: 'texas.burntSienna.500',
  color: 'white',
  _hover: { background: 'texas.burntSienna.500' },
});

const globalNavigationUtility = defineStyle({
  ...globalNavigation,
  gap: 0.5,
  width: '38px',
  height: '42px',
});

const globalNavigationUtilityActive = defineStyle({
  ...globalNavigationUtility,
  background: 'texas.burntSienna.500',
  color: 'white',
  _hover: { background: 'texas.burntSienna.500' },
});

const contextNavigation = defineStyle({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  position: 'relative',
  height: 8,
  paddingX: 2.5,
  color: 'navigation.contextMuted',
  fontFamily: 'instrumentSans',
  fontSize: '13px',
  fontWeight: 'normal',
  textDecoration: 'none',
  _hover: {
    background: 'navigation.contextActiveBackground',
    color: 'chakra-body-text',
  },
});

const contextNavigationActive = defineStyle({
  ...contextNavigation,
  background: 'navigation.contextActiveBackground',
  color: 'chakra-body-text',
  fontWeight: 'semibold',
  _before: {
    content: '""',
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    width: '3px',
    background: 'texas.burntSienna.500',
  },
});

const navigationBreadcrumb = defineStyle({
  display: 'flex',
  alignItems: 'center',
  minWidth: 0,
  color: 'navigation.contextMuted',
  textDecoration: 'none',
  _hover: { color: 'navigation.breadcrumbCurrent' },
});

const navigationUtility = defineStyle({
  display: 'flex',
  flex: 1,
  alignItems: 'center',
  justifyContent: 'center',
  height: 9,
  minWidth: 9,
  flexShrink: 0,
  color: 'navigation.contextMuted',
  textDecoration: 'none',
  _hover: {
    background: 'navigation.contextActiveBackground',
    color: 'texas.burntSienna.500',
  },
});

const navigationUtilityActive = defineStyle({
  ...navigationUtility,
  background: 'navigation.contextActiveBackground',
  color: 'texas.burntSienna.500',
});

const navigationReference = defineStyle({
  display: 'flex',
  alignItems: 'center',
  minHeight: 6,
  marginTop: -3,
  marginBottom: 2,
  color: 'navigation.contextMuted',
  fontSize: '12px',
  textDecoration: 'none',
  _hover: { color: 'texas.burntSienna.500' },
});

const entityDirectoryBadge = defineStyle({
  color: 'inherit',
  textDecoration: 'none',
  _hover: { color: 'texas.burntSienna.500' },
});

const entityDirectoryMuted = defineStyle({
  color: 'entityDirectory.mutedText',
  fontSize: '12px',
});

export default defineStyleConfig({
  defaultProps: { variant: 'underline' },
  variants: {
    contextNavigation,
    contextNavigationActive,
    entityDirectoryBadge,
    entityDirectoryMuted,
    globalNavigation,
    globalNavigationActive,
    globalNavigationUtility,
    globalNavigationUtilityActive,
    navigationBar,
    navigationBreadcrumb,
    navigationReference,
    navigationUtility,
    navigationUtilityActive,
    underline,
  },
});
